import { useCallback, useEffect, useState } from "react";
import { getPerpsFunding } from "@/lib/hyperliquid";

export interface PerpsFundingDailyPoint {
  day: string;
  funding: number;
}

export interface PerpsFundingResponse {
  walletId: string;
  rangeDays: number;
  startTimeMs: number;
  endTimeMs: number;
  totals: {
    totalFunding: number;
  };
  daily: PerpsFundingDailyPoint[];
  events: any[];
}

interface UsePerpsFundingReturn {
  data: PerpsFundingResponse | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function usePerpsFunding(address: string | undefined, rangeDays: number): UsePerpsFundingReturn {
  const [data, setData] = useState<PerpsFundingResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!address) return;

    setIsLoading(true);
    setError(null);

    try {
      const res = await getPerpsFunding(address, rangeDays);
      setData(res);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Failed to fetch funding history";
      setError(message);
    } finally {
      setIsLoading(false);
    }
  }, [address, rangeDays]);

  useEffect(() => {
    if (address) {
      refresh();
    }
  }, [address, rangeDays, refresh]);

  return { data, isLoading, error, refresh };
}
